import { createAction } from 'redux-actions-helpers'
import { BlockType } from '@famiryru/react-notion-renderer/src/types'

export const fetchNotionPage = createAction(
  '@@notion-page/FETCH_NOTION_PAGE',
  (pageId: string, key: string): any => ({ pageId, key })
)

export const fetchNotionPageSuccess = createAction(
  '@@notion-page/FETCH_NOTION_PAGE_SUCCESS',
  (blocks: BlockType[]): any => ({ blocks })
)

export const fetchNotionPageFailure = createAction(
  '@@notion-page/FETCH_NOTION_PAGE_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@notion-page/DESTROY')
